import logo from './logo.svg';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Founder from './components/Founder';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';
function App() {
  return (
    <div>
      <Navbar />
 <Hero />
 <About />
 <Founder />
 <Services />
 <Contact />
 <Footer />
    </div>
  );
}

export default App;
